import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'react-virtualized';
import PropTypes from 'prop-types';
import $ from "jquery";

import NavigationItemsList from "../navigationItemsList";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {UserPopupTypes} from "../../constants";
import {getActivePartsCounts} from "../navUtils";
import {
  changeActivePartRelatedItemIndex, setCameFromPage, setQtActiveCategory, toggleBathroomVisualizerOpen,
  toggleSelectionFeatureInfo, toggleSelectionWindow
} from "../../../../actions/actionFunctions";

import BodySwipable from "./bodySwipable";
import LoadingSpinner from "../../../ui/loadingSpinner";
import {checkIfNeedToReceiveFeaturesIfFiltersApplied} from "../../../../misc/filtersFunctions";

class BodyItemsClass extends NavigationItemsList {

  static propTypes = {
    features: PropTypes.arrayOf(PropTypes.instanceOf(DesignNavigationItem)),
    parentItem: PropTypes.instanceOf(DesignNavigationItem),
    childItem: PropTypes.instanceOf(DesignNavigationItem),
    onItemClick: PropTypes.func,
    showMenu: PropTypes.bool,
    existInQtCategory: PropTypes.bool,
    toggleUserPopup: PropTypes.func,
    activeFeature: PropTypes.object,
    searchText: PropTypes.string,
    layoutName: PropTypes.string,
    parentUpdate: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      showPlaceHolders: document.bvConfig ? document.bvConfig.showPlaceholders : false,
      reorderedFeatures: [],
      showLoader: false,
      childItemText: "",
      parentItemText: "",
      additionalFeaturesLoading: false
    };
  }

  componentDidMount() {
    this.reorderItems(this.props);
    const childItem = this.props.childItem && this.props.childItem.part;
    if (childItem && childItem.partId.includes("countertop") && this.props.selectedFilters.length && !this.props.activeNavigationFilter) {
      const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(this.props.selectedFilters, childItem);
      if (checkPassed) {
        this.getFeaturesFromBackendWithFilters(childItem, checkPassed.arrayOfNeededFiltersToReceive, 1);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.childItem && (nextProps.childItem.text !== this.state.childItemText))
        || (nextProps.showMenu && !this.props.showMenu)
        || (!nextProps.childItem && nextProps.parentItem && (nextProps.parentItem.text !== this.state.parentItemText))
        || (this.props.selectedFilters.length !== nextProps.selectedFilters.length)
        || (this.props.searchText !== nextProps.searchText)
        || (nextProps.allFeaturesReceived && !this.props.allFeaturesReceived)
        || (nextProps.bvOpened && !this.props.bvOpened)
        || (this.props.features.length && nextProps.features.length && nextProps.features[0] && this.props.features[0]
      && nextProps.features[0].part.getParent && this.props.features[0].part.getParent
      && nextProps.features[0].part.getParent().partName !== this.props.features[0].part.getParent().partName)
    ) {
      this.setState({
        showLoader: true
      }, () => {
        this.reorderItems(nextProps);
      });
    }
    if (!nextProps.filtersVisible && this.props.filtersVisible) {
      setTimeout(() => {
        this.forceUpdate()
      }, 200);
    }
    if (this.needToUpdate && nextProps.features.length !== this.props.features.length) {
      this.reorderItems(nextProps);
    }
    if (nextProps.childItem && nextProps.selectedFilters.length) {
      const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(nextProps.selectedFilters, nextProps.childItem.part);
      if (checkPassed) {
        this.setState({
          additionalFeaturesLoading: true
        })
        this.getFeaturesFromBackendWithFilters(nextProps.childItem.part, checkPassed.arrayOfNeededFiltersToReceive, 1);
      }
    }
  }

  reorderItems = (props) => {
    const selectedFirstItemIndex = this.getActiveItemIndex(props);
    const otherSelectedWallsIndexes = this.getSelectedWallIndexes(props.childItem, props.features, selectedFirstItemIndex); // this part is looking for the same stones that are already selected

    const selectedExist = (selectedFirstItemIndex || selectedFirstItemIndex === 0) && selectedFirstItemIndex > -1;
    const indexesToReplace = selectedExist ? [selectedFirstItemIndex, ...otherSelectedWallsIndexes] : [...otherSelectedWallsIndexes];

    // console.log('indexesToReplace', indexesToReplace);

    this.setState({
      childItemText: props.childItem ? props.childItem.text : "",
      parentItemText: props.parentItem ? props.parentItem.text : "",
      reorderedFeatures: this.getReorderedItems(indexesToReplace, props, selectedExist)
    }, () => {
      this.setState({
        showLoader: false
      });
      if (this.needToUpdate) {
        const $gridBody = $(".categories-list .ReactVirtualized__Grid");
        $gridBody.scrollLeft(this.needToUpdate);
        this.needToUpdate = false;
      }
    });
  };

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    const fabricatorSettings = this.props.fabricatorData.settings;

    if (this.props.userIsLoggedIn) {
      if (fabricatorSettings.twoFA) {
        if (!this.props.isPhoneNumberValidated) {
          this.props.toggleUserPopup({
            userPopupOpened: true,
            userPopupType
          });
        } else {
          this.toggleMobileButton('userLogoutActive');
        }
      } else {
        this.toggleMobileButton('userLogoutActive');
      }
    } else {
      this.props.toggleUserPopup({
        userPopupOpened: true,
        userPopupType
      });
      if (userPopupType === UserPopupTypes.GetQuote) {
        window.allowClickLeadCapturePopup = false;
      }
    }
  };

  toggleMobileButton = (activeFeature) => {
    this.setState({
      [activeFeature]: !this.state[activeFeature]
    })
  };

  renderVirtualizedGrid = () => {

    const elements = this.getNavItemsList();
    const menuBody = document.querySelector(".categories-list");
    const navigationViewType = this.props.navigationViewType === 3 ? 2 : 1; // 2
    const columnsCount = Math.ceil(elements.length / navigationViewType); // for ex. 28/3 = 10 columns

    const list = [[]];  // making list for React Virtualized
    if (navigationViewType === 2) {
      list.push([]);
      elements.forEach((element, index) => {
        let rowIndex = (index % navigationViewType === 0) ? 0 : 1;
        list[rowIndex].push(React.cloneElement(element))
      });
    } else {
      elements.forEach((element) => list[0].push(React.cloneElement(element)));
    }

    // console.log('list', list);

    return menuBody ? (
      <Fragment>
        <BodySwipable scrollableSelector={".categories-list .ReactVirtualized__Grid"}>
          <Grid rowCount={list.length}
                columnCount={columnsCount}  // 2 or 4
                width={menuBody.clientWidth - 1}
                height={menuBody.clientHeight}
                onScroll={this.onDesktopNavigationScroll}
                columnWidth={(navigationViewType === 2) ? 179 : 244}
                rowHeight={(navigationViewType === 2) ? 125 : 242}
                cellRenderer={({columnIndex, key, rowIndex, style}) => {
                  return <div key={key} style={style}>
                    {list[rowIndex][columnIndex]}
                  </div>
                }}>
          </Grid>
        </BodySwipable>
      </Fragment>
    ) : null
  };

  renderLoadingList = (activePart) => {
    if (!activePart.counts) {
      return <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
    }

    const counts = getActivePartsCounts(activePart, this.props.layoutName);

    if (!counts) {
      return <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
    }

    const navigationViewType = this.props.navigationViewType === 3 ? 2 : 1;

    const elements = [];
    for (let i = 0; i < Math.ceil(counts / navigationViewType); i++ ) {  // for ex. 28/3 = 10 columns
      const innerElements = [];
      for (let j = 0; j < navigationViewType;j++ ) {
        const currentIndex = j+(i*navigationViewType);
        if (currentIndex < counts) {
          innerElements.push(
            <div className="feature" key={"loading-feature"+currentIndex}>
              <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
            </div>
          );
        }
      }
      elements.push(
        <li className="features-list__item" style={{verticalAlign: "top"}} key={"features-list__item"+i}>
          {innerElements}
        </li>
      );
    }

    return elements
  };

  render() {
    const activePart    = this.props.parentItem ? this.props.parentItem.part : null;
    const activeSubPart = this.props.childItem ? this.props.childItem.part : null;

    return (
      <div className={"categories-list categories-list--"+ this.props.navigationViewType
      + (this.props.parentItem ? " categories-list--grid" : "") + (this.props.filtersVisible ? " categories-list--filters-visible" : "")}>
        {this.state.showLoader
          ? <LoadingSpinner/>
          : this.props.allFeaturesReceived
            ? (
              <Fragment>
                {this.state.additionalFeaturesLoading || this.props.navigationLoadingActive ? this.getLoadingFeatures() : null}
                {this.renderVirtualizedGrid()}
              </Fragment>
            )
            : this.renderLoadingList(activeSubPart || activePart)
        }
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {isPhoneNumberValidated, userIsLoggedIn} = store.userState;
  return {
    isPhoneNumberValidated,
    userIsLoggedIn,
    bvOpened: store.bathroomVisualizerState.bvOpened,
    filtersVisible: store.filterState.showFilters,
    selectedFilters: store.filterState.selectedFilters,
    filterGroups: store.filterState.filterGroups,
    fabricatorData: store.fabricatorState,
    cartItems: store.cartState.cartItems,
    navigationViewType: store.navigationState.navigationViewType,
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    navigationLoadingActive: store.navigationState.navigationLoadingActive,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    windowWidth: store.serverState.windowWidth, // re-render grid on resize
  }
};

const mapDispatchToProps = {
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  setCameFromPage,
  setQtActiveCategory,
  toggleBathroomVisualizerOpen
};

const BodyItems = connect(mapStateToProps, mapDispatchToProps)(BodyItemsClass);


export default BodyItems;
